import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { Observable, Subject, takeUntil } from 'rxjs';
import { updateTenderDate } from 'src/app/core/store/form.actions';
import { MyPurchaseForm } from 'src/app/shared/models/app-models';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from 'src/app/data/constants/Data';
@Component({
  selector: 'app-tender-date-time-form',
  templateUrl: './tender-date-time-form.component.html',
  styleUrls: ['./tender-date-time-form.component.scss'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }],
})
export class TenderDateTimeFormComponent implements OnDestroy, OnChanges {
  @Input() isReadOnly: boolean = false;
  store$: Observable<MyPurchaseForm>;
  tenderDateTimeForm!: FormGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  OpenDateControl!: FormControl;
  StartTimeControl!: FormControl;
  CloseDateControl!: FormControl;
  EndTimeControl!: FormControl;
  minDate: Date = new Date();
  tenderDateTimeItem!: any;
  tooltipInfo: string = `This date is to be filled by your 
  assigned Contracting Executive`;
  boundFilterCloseDate = this.filterCloseDate.bind(this);
  updateFromStore: boolean = false;
  constructor(
    private _fb: FormBuilder,
    private store: Store<{
      form: MyPurchaseForm;
    }>
  ) {
    this.store$ = this.store.select('form');
    this.tenderDateTimeForm = this._fb.group({
      OpenDate: null,
      StartTime: '',
      CloseDate: null,
      EndTime: '',
    });

    this.OpenDateControl = this.tenderDateTimeForm.controls[
      'OpenDate'
    ] as FormControl;
    this.StartTimeControl = this.tenderDateTimeForm.controls[
      'StartTime'
    ] as FormControl;
    this.CloseDateControl = this.tenderDateTimeForm.controls[
      'CloseDate'
    ] as FormControl;
    this.EndTimeControl = this.tenderDateTimeForm.controls[
      'EndTime'
    ] as FormControl;
  }

  async ngOnInit(): Promise<void> {
    this.store$
      .pipe(takeUntil(this.destroy$))
      .subscribe((s: MyPurchaseForm) => {
        console.log(s, 'for tender date')
        this.tenderDateTimeForm.setValue(
          {
            OpenDate: s.TenderStartDate,
            CloseDate: s.TenderEndDate,
            StartTime: s.TenderStartTime,
            EndTime: s.TenderEndTime
          }
        )
        this.updateFromStore = true
      });
    this.tenderDateTimeForm.valueChanges.subscribe((value: any) => {
      if (this.updateFromStore) {
        this.updateFromStore = false;
        return;
      }
      this.updateForm();
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isReadOnly"]) {
      if (changes["isReadOnly"].currentValue == true) {
        this.tenderDateTimeForm.disable();
      }
      else {
        this.tenderDateTimeForm.enable();
      }
    }
  }
  updateForm() {
    // const StartDate = this.OpenDateControl.value as Date;
    // const EndDate = this.CloseDateControl.value as Date;

    // // set the time 
    // if (StartDate) {
    //   StartDate.setHours(this.StartTimeControl.value && this.StartTimeControl.valid ? Number(this.StartTimeControl.value.split(':')[0]) : 0, this.StartTimeControl.value && this.StartTimeControl.valid ? Number(this.StartTimeControl.value.split(':')[1]) : 0, 0, 0)
    // }

    // if (EndDate) {
    //   EndDate.setHours(this.EndTimeControl.value && this.EndTimeControl.valid ? Number(this.EndTimeControl.value.split(':')[0]) : 0, this.EndTimeControl.value && this.EndTimeControl.valid ? Number(this.EndTimeControl.value.split(':')[1]) : 0, 0, 0)
    // }
    this.store.dispatch(updateTenderDate({
      TenderDate:
      {
        StartDate: this.OpenDateControl.value instanceof Date ? this.OpenDateControl.value : this.OpenDateControl.value.toDate(),
        EndDate: this.CloseDateControl.value instanceof Date ? this.CloseDateControl.value : this.CloseDateControl.value.toDate(),
        StartTime: this.StartTimeControl.value,
        EndTime: this.EndTimeControl.value
      }
    }))
  }

  onStartDateChange() {
    // clear close date if open date selected is later than close date
    if (this.CloseDateControl.value < this.OpenDateControl.value) {
      this.CloseDateControl.reset(null);
    }

  }

  filterCloseDate(d: Date | null): boolean {
    // filter closeDate option based on selected openDate. It should be later than open date.
    const openDate = this.OpenDateControl.value ? this.OpenDateControl.value : new Date();

    return openDate <= (d ?? new Date());

  }
}
